/**
 * The arithmetic behind drag to fund (v8.0.0). PURE — no DOM, so the unit suite
 * can test it inside workerd. The wiring is in ./drag-fund.ts.
 */

/** Travel, in CSS pixels, before a press becomes a drag. */
export const DRAG_THRESHOLD_PX = 6;

export function travelled(dx: number, dy: number, threshold = DRAG_THRESHOLD_PX): boolean {
  return dx * dx + dy * dy >= threshold * threshold;
}

/** Room kept between the label and the screen edge, and above the pointer. */
const EDGE_PX = 8;
const ABOVE_PX = 56;

/**
 * Where the "Drop on an envelope" label goes: centred ABOVE the pointer, where a
 * finger does not cover it, and clamped inside the screen. The first version sat
 * to the right of the pointer and ran off a phone's edge mid-sentence — seen in
 * a screenshot, not caught by any assertion.
 */
export function ghostPosition(
  x: number,
  y: number,
  width: number,
  viewportWidth: number,
): { left: number; top: number } {
  const max = Math.max(EDGE_PX, viewportWidth - width - EDGE_PX);
  return {
    left: Math.min(Math.max(x - width / 2, EDGE_PX), max),
    top: Math.max(EDGE_PX, y - ABOVE_PX),
  };
}
